import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
interface TooltipProps {
  content: string;
  children: React.ReactNode;
  delay?: number;
}
export function Tooltip({
  content,
  children,
  delay = 1000
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({
    top: 0,
    left: 0
  });
  const timeoutRef = useRef<NodeJS.Timeout>();
  const triggerRef = useRef<HTMLDivElement>(null);
  const handleMouseEnter = () => {
    timeoutRef.current = setTimeout(() => {
      if (triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        setPosition({
          top: rect.top - 10,
          left: rect.left + rect.width / 2
        });
        setIsVisible(true);
      }
    }, delay);
  };
  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsVisible(false);
  };
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return <div ref={triggerRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="inline-block" data-id="element-2083" data-mp="10xie3bavwfwr">
      {children}
      {isVisible && createPortal(<div className="fixed z-50 px-2 py-1 text-xs font-medium text-white bg-slate-800 rounded shadow-lg transform -translate-x-1/2 -translate-y-full pointer-events-none whitespace-nowrap" style={{
      top: position.top,
      left: position.left
    }} data-id="element-2084" data-mp="1ao4o8pzu0e82">
            {content}
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 border-4 border-transparent border-t-slate-800" data-id="element-2085" data-mp="mwfst0rpr9mw"></div>
          </div>, document.body)}
    </div>;
}